import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, AlertTriangle, Lock } from 'lucide-react';
import { Button } from './ui/Button';
export function CheckoutSection() {
  const [selectedCombo, setSelectedCombo] = useState(1);
  const handlePurchase = (url: string, price: number, name: string) => {
    if (window.fbq) {
      window.fbq('track', 'InitiateCheckout', {
        content_name: name,
        currency: 'USD',
        value: price
      });
    }
    window.location.href = url;
  };
  const combos = [{
    name: 'COMPLETO PARA EMPEZAR',
    shortName: 'Combo 1',
    price: 13.99,
    oldPrice: 27.99,
    discount: '50% OFF',
    features: [{
      text: 'Manual Principal Huerta 360º (PDF digital)',
      type: 'normal'
    }, {
      text: 'Bonus 1: Calendario Productivo Anual (PDF digital)',
      type: 'bonus'
    }, {
      text: 'Bonus 2: Fertilizantes Naturales & Bioinsumos (PDF digital)',
      type: 'bonus'
    }, {
      text: 'Bonus 3: Mini Invernadero Low Cost (PDF digital)',
      type: 'bonus'
    }, {
      text: 'Acceso automático por email',
      type: 'normal'
    }, {
      text: 'Acceso de por vida',
      type: 'normal'
    }],
    link: 'https://pay.hotmart.com/U104645462P',
    recommended: false
  }, {
    name: 'MÁS ELEGIDO',
    shortName: 'Combo 2',
    price: 19.9,
    oldPrice: 39.9,
    discount: 'AHORRA $20',
    features: [{
      text: 'Manual Principal Huerta 360º (PDF digital)',
      type: 'normal'
    }, {
      text: 'Manual 2: Huerta Intensiva (PDF digital)',
      type: 'highlight'
    }, {
      text: 'Bonus 1: Calendario Productivo Anual (PDF digital)',
      type: 'bonus'
    }, {
      text: 'Bonus 2: Fertilizantes Naturales & Bioinsumos (PDF digital)',
      type: 'bonus'
    }, {
      text: 'Bonus 3: Mini Invernadero Low Cost (PDF digital)',
      type: 'bonus'
    }, {
      text: 'Acceso automático por email',
      type: 'normal'
    }, {
      text: 'Acceso de por vida',
      type: 'normal'
    }],
    link: 'https://pay.hotmart.com/P104645626I',
    recommended: true
  }, {
    name: 'NIVEL EMPRENDEDOR',
    shortName: 'Combo 3',
    price: 26.9,
    oldPrice: 53.9,
    discount: 'MEJOR VALOR',
    features: [{
      text: 'Manual Principal Huerta 360º (PDF digital)',
      type: 'normal'
    }, {
      text: 'Manual 2: Huerta Intensiva (PDF digital)',
      type: 'highlight'
    }, {
      text: 'Manual 3: Emprendimiento (PDF digital)',
      type: 'highlight'
    }, {
      text: 'Bonus 1: Calendario Productivo Anual (PDF digital)',
      type: 'bonus'
    }, {
      text: 'Bonus 2: Fertilizantes Naturales & Bioinsumos (PDF digital)',
      type: 'bonus'
    }, {
      text: 'Bonus 3: Mini Invernadero Low Cost (PDF digital)',
      type: 'bonus'
    }, {
      text: 'Acceso automático por email',
      type: 'normal'
    }, {
      text: 'Acceso de por vida',
      type: 'normal'
    }],
    link: 'https://pay.hotmart.com/Q104645750F',
    recommended: false
  }];
  const currentCombo = combos[selectedCombo];
  return <section id="checkout" className="py-16 px-4 bg-zinc-950" data-id="element-38">
      <div className="max-w-3xl mx-auto" data-id="element-39">
        <div className="text-center mb-8" data-id="element-40">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-white mb-4" data-id="element-41">
            Elige Tu Nivel
          </h2>
          <motion.div animate={{
          opacity: [1, 0.7, 1]
        }} transition={{
          duration: 1.5,
          repeat: Infinity
        }} className="inline-flex items-center gap-2 bg-red-900/30 border border-red-500/50 text-red-400 px-4 py-2 rounded-lg font-bold mb-6" data-id="element-42">
            <AlertTriangle className="w-5 h-5" data-id="element-43" />
            Oferta con bonos por tiempo limitado
          </motion.div>

          <div className="flex flex-col items-center gap-2 mb-8" data-id="element-44">
            <div className="flex items-center gap-2 text-zinc-400 text-sm" data-id="element-45">
              <Lock className="w-4 h-4 text-green-500" data-id="element-46" />
              <span data-id="element-47">Pago 100% seguro procesado por</span>
            </div>
            <div className="bg-white px-4 py-2 rounded-lg" data-id="element-48">
              <img src="https://cdn.magicpatterns.com/uploads/g4uEDtvwrbY7ZFknKXtM5W/pasted-image.svg" alt="Hotmart" className="h-6 object-contain" data-id="element-49" />
            </div>
          </div>
        </div>

        {/* Combo Selector Tabs */}
        <div className="bg-zinc-900 rounded-2xl border border-zinc-800 overflow-hidden" data-id="element-50">
          <div className="grid grid-cols-3 border-b border-zinc-800" data-id="element-51">
            {combos.map((combo, index) => <button key={index} onClick={() => setSelectedCombo(index)} className={`relative py-4 px-2 sm:px-4 text-center transition-all duration-200 ${selectedCombo === index ? 'bg-zinc-800 border-b-2 border-green-500' : 'hover:bg-zinc-800/50'}`} data-id="element-52">
                {combo.recommended && <span className="absolute -top-0 left-1/2 -translate-x-1/2 bg-green-600 text-white text-[10px] font-bold px-2 py-0.5 rounded-b" data-id="element-53">
                    Más Vendido
                  </span>}
                <div className={`text-xs sm:text-sm font-bold ${selectedCombo === index ? 'text-white' : 'text-zinc-400'}`} data-id="element-54">
                  {combo.shortName}
                </div>
                <div className={`text-lg sm:text-xl font-extrabold ${selectedCombo === index ? 'text-green-500' : 'text-zinc-500'}`} data-id="element-55">
                  ${combo.price.toFixed(2)}
                </div>
              </button>)}
          </div>

          {/* Selected Combo Content */}
          <AnimatePresence mode="wait" data-id="element-56">
            <motion.div key={selectedCombo} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -10
          }} transition={{
            duration: 0.2
          }} className="p-6" data-id="element-57">
              <h3 className="text-xl font-bold text-white mb-4 text-center" data-id="element-58">
                {currentCombo.name}
              </h3>

              <ul className="space-y-2 mb-6" data-id="element-59">
                {currentCombo.features.map((feature, i) => <li key={i} className="flex items-start gap-3 text-sm" data-id="element-60">
                    <Check className={`w-5 h-5 shrink-0 ${feature.type === 'highlight' ? 'text-amber-400' : 'text-green-500'}`} data-id="element-61" />
                    <span className={feature.type === 'highlight' ? 'text-amber-400 font-medium' : feature.type === 'bonus' ? 'text-zinc-300' : 'text-zinc-300'} data-id="element-62">
                      {feature.text}
                      {feature.type === 'bonus' && <span className="text-green-500 font-bold ml-1" data-id="element-63">
                          (GRATIS)
                        </span>}
                    </span>
                  </li>)}
              </ul>

              <div className="text-center border-t border-zinc-800 pt-6" data-id="element-64">
                <div className="flex items-center justify-center gap-3 mb-2" data-id="element-65">
                  <span className="text-zinc-500 line-through text-lg" data-id="element-66">
                    USD ${currentCombo.oldPrice.toFixed(2)}
                  </span>
                  <span className="text-green-500 font-bold text-sm bg-green-900/30 px-2 py-1 rounded" data-id="element-67">
                    {currentCombo.discount}
                  </span>
                </div>
                <div className="text-4xl font-extrabold text-white mb-1" data-id="element-68">
                  USD ${currentCombo.price.toFixed(2)}
                </div>
                <p className="text-xs text-zinc-500 mb-4" data-id="element-69">
                  Puedes pagar en tu moneda local: COP, CLP, MXN
                </p>

                <Button variant="primary" size="lg" className="w-full" onClick={() => handlePurchase(currentCombo.link, currentCombo.price, currentCombo.name)} data-id="element-70">
                  COMPRAR AHORA
                </Button>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </section>;
}